import { render, staticRenderFns } from "./ItemTileDeleteBtn.vue?vue&type=template&id=7efcf1bb&scoped=true&"
import script from "./ItemTileDeleteBtn.vue?vue&type=script&lang=js&"
export * from "./ItemTileDeleteBtn.vue?vue&type=script&lang=js&"
import style0 from "./ItemTileDeleteBtn.vue?vue&type=style&index=0&id=7efcf1bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efcf1bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListTileAction } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VListTileAction,VTooltip})
